import { render, staticRenderFns } from "./CaseSpineAssessment.vue?vue&type=template&id=3cd6dd57&scoped=true&"
import script from "./CaseSpineAssessment.vue?vue&type=script&lang=js&"
export * from "./CaseSpineAssessment.vue?vue&type=script&lang=js&"
import style0 from "./CaseSpineAssessment.vue?vue&type=style&index=0&id=3cd6dd57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6dd57",
  null
  
)

export default component.exports